import React from "react";

import { styled } from "@mui/material/styles";
import { Box, Typography, CircularProgress } from "@mui/material";

import CollapseCard from "components/Collapse";
import TwoColumnContainer from "components/Container/TwoColumnContainer";

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.customFontSize[2],
  color: theme.palette.primary.black,
  fontWeight: theme.typography.customFontWeight[1],
}));

const AdvancePanel = ({ capabilityData, advanceLoading, advanceData }) => {
  const fields = [
    // { key: "IGMPSnooping", label: "IGMP Snooping" },
    { key: "DDP", label: "DDP" },
    // { key: "RSTP", label: "RSTP" },
    { key: "LBD", label: "LBD" },
  ];

  return (
    capabilityData.tunnelAccess === true ? null : (<CollapseCard title="Advance">
      {
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {(advanceLoading &&
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                alignItems: "center",
                justifyContent: "center",
                width: "100%"
              }}>
              <CircularProgress />
            </Box>) ||
            fields.map(({ key, label }) => (
              <TwoColumnContainer key={key} label={label}>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}>
                  <StyledTypography>{advanceData[key]}</StyledTypography>
                </Box>
              </TwoColumnContainer>
            ))
          }
        </Box>
      }
    </CollapseCard>
    )
  );
};

export default AdvancePanel;
